import { render, staticRenderFns } from "./HiBase.vue?vue&type=template&id=38733fd5&scoped=true&"
import script from "./HiBase.vue?vue&type=script&lang=js&"
export * from "./HiBase.vue?vue&type=script&lang=js&"
import style0 from "./HiBase.vue?vue&type=style&index=0&id=38733fd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38733fd5",
  null
  
)

export default component.exports